import React, { useState, useEffect } from "react";
import Timer from "../components/Timer";
import LoadingTimer from "../components/LoadingTimer";
import Container from '@material-ui/core/Container';
import Grid from '@material-ui/core/Grid';
import AssetGrid from "../components/AssetGrid";
import TopFields from "../components/TopFields";
import Reminder from "../components/Reminder";
import { PubSub, API } from "aws-amplify";
import Backdrop from '@material-ui/core/Backdrop';
import CircularProgress from '@material-ui/core/CircularProgress';
import { makeStyles } from '@material-ui/core/styles';
import { insertError } from "../libs/hooksLib";
import Box from '@material-ui/core/Box';
import Snackbar from '@material-ui/core/Snackbar';
import MuiAlert from '@material-ui/lab/Alert';

function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}

const useStyles = makeStyles(theme => ({
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: '#fff',
  }
}));

const menuList = [ 'Unavailable' ,'Off Day', 'MCC', 'MC', 'Period' ,'Toilet', 'Meal'];
const initRooms = [{ "startTime": "2020-07-23T08:59:30.720Z", "extend": true, "endTime": "2020-07-23T09:52:15.817Z", "onlineStatus": false, "roomId": "room3", "roomNum": 3, "roomName": "Room 3", "price": 0, "type": "M" }, { "startTime": "2020-07-26T00:47:37.877Z", "endTime": "2020-07-26T02:00:03.745Z", "onlineStatus": true, "roomId": "room17", "roomNum": 17, "roomName": "Room 17", "price": 0, "type": "M" }, { "startTime": "2020-07-19T06:49:06.743Z", "endTime": "2020-07-21T08:20:33.166Z", "onlineStatus": true, "roomId": "room8", "roomNum": 8, "roomName": "Room 8", "price": 0, "type": "VIP" }, { "startTime": "2020-07-26T02:00:13.796Z", "endTime": "2020-07-26T02:00:22.976Z", "onlineStatus": false, "roomId": "room12", "roomNum": 12, "roomName": "Room 12", "price": 0, "type": "VIP" }, { "startTime": "2020-07-23T09:07:32.146Z", "endTime": "2020-07-23T09:07:38.546Z", "onlineStatus": false, "roomId": "room11", "roomNum": 11, "roomName": "Room 11", "price": 0, "type": "S" }, { "startTime": "2020-07-18T08:52:43.981Z", "endTime": "2020-07-21T08:20:37.630Z", "onlineStatus": false, "roomId": "room15", "roomNum": 15, "roomName": "Room 15", "price": 0, "type": "VIP" }, { "startTime": "2020-07-23T08:03:04.779Z", "endTime": "2020-07-23T08:03:47.821Z", "onlineStatus": false, "roomId": "room7", "roomNum": 7, "roomName": "Room 7", "price": 0, "type": "S" }, { "startTime": "2020-07-19T08:18:33.037Z", "endTime": "2020-07-21T08:20:39.923Z", "onlineStatus": false, "roomId": "room13", "roomNum": 13, "roomName": "Room 13", "price": 0, "type": "M" }, { "startTime": "2020-07-18T08:52:08.723Z", "endTime": "2020-07-21T08:20:29.626Z", "onlineStatus": false, "roomId": "room2", "roomNum": 2, "roomName": "Room 2", "price": 0, "type": "S" }, { "startTime": "2020-08-01T02:16:38.881Z", "endTime": "2020-08-01T02:17:08.365Z", "onlineStatus": true, "roomId": "room18", "roomNum": 18, "roomName": "Room 18", "price": 0, "type": "M" }, { "startTime": "2020-07-19T06:50:38.065Z", "endTime": "2020-07-19T07:19:15.847Z", "onlineStatus": true, "roomId": "room9", "roomNum": 9, "roomName": "Room 9", "price": 0, "type": "VIP" }, { "startTime": "2020-07-18T08:52:48.109Z", "endTime": "2020-07-18T09:12:55.481Z", "onlineStatus": false, "roomId": "room5", "roomNum": 5, "roomName": "Room 5", "price": 0, "type": "M" }, { "startTime": "2020-07-18T08:52:26.756Z", "endTime": "2020-07-18T09:13:01.423Z", "onlineStatus": false, "roomId": "room10", "roomNum": 10, "roomName": "Room 10", "price": 0, "type": "S" }, { "startTime": "2020-07-25T23:57:16.018Z", "endTime": "2020-07-26T00:25:32.129Z", "onlineStatus": true, "roomId": "room1", "roomNum": 1, "roomName": "Room 1", "price": 0, "type": "VIP" }];

export default function MainRoom(props) {
  const classes = useStyles();
  const [loading, setLoading] = React.useState(false);
  const [packages, setPackages] = useState("");
  const [assetList, updateAssetList] = useState("");
  const [rooms, setRooms] = useState("");
  const [selectedAsset, setSelectedAsset] = useState("");
  const [pubSub, setPubSub] = useState("");
  const [price, setPrice] = useState(0);
  const [errorOpen, setErrorOpen] = React.useState(false);

  const handleErrorClick = () => {
    setErrorOpen(true);
  };

  const handleErrorClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setErrorOpen(false);
  };

  useEffect(() => {
    PubSub.subscribe("main").subscribe({
      next: data => setPubSub(data),
      error: error => console.error(error),
      close: () => console.log('Done'),
    });
  }, []);

  useEffect(() => {
    setLoading(true);
    setRooms("");

    function onLoad() {

      API.get("apiaada51cc", '/rooms').then(response => {
        setLoading(false);
        setRooms(response.data.sort((a, b) => (a.roomNum - b.roomNum)));
      }).catch(error => {
        handleErrorClick();
        insertError(error);
      });

      API.get("apiaada51cc", '/packages').then(response => {
        setLoading(false);
        setPackages(response.data.sort((a, b) => (a.price - b.price)));
      }).catch(error => {
        handleErrorClick();
        insertError(error);
      });

    }
    onLoad();
  }, []);


  useEffect(() => {
    async function refresh() {
      await API.get("apiaada51cc", '/assets').then(response => {
        updateAssetList(response.data.sort((a, b) => (a.assetId - b.assetId)));
      }).catch(error => {
        handleErrorClick();
        insertError(error);
      });

      await API.get("apiaada51cc", '/rooms').then(response => {
        setRooms(response.data.sort((a, b) => (a.roomNum - b.roomNum)));
      }).catch(error => {
        handleErrorClick();
        insertError(error);
      });

    }
    refresh();
  }, [pubSub]);

  async function getAssetPrice(assetName) {
    const getAssets = await API.get("apiaada51cc", "/assets");
    const price = getAssets.data.filter(it => assetName === it.assetName)[0].price;
    return price;
  }

  async function updateTracking(assetId, tracking, price) {
    setLoading(true);
    const currentTime = new Date().toISOString();

    updateAssetList(assetList.map(el => (el.assetId === assetId ? Object.assign({}, el, { tracking: tracking, updatedTime: currentTime }) : el)));
    if (assetId === "" || assetId === null) return new Error("Invalid Girl");

    const options = {
      headers: { 'Content-Type': 'application/json', "Access-Control-Allow-Origin": "*" },
      body: {
        tracking: tracking,
        price: price,
        updatedTime: currentTime
      }
    };
    await API.put("apiaada51cc", `/assets/${assetId}`, options).then(response => {
      // Add your code here
      setLoading(false);
      setPubSub("Transaction updated" + Math.random());
    }).catch(error => {
      handleErrorClick();
      insertError(error);
    });

    await PubSub.publish("meal", { msg: 'Tracking Update' });

  }

  async function updateRoomStatus(roomId, roomDisabled) {
    console.log(roomId, roomDisabled);
    const options = {
      headers: { 'Content-Type': 'application/json', "Access-Control-Allow-Origin": "*" },
      body: {
        roomDisabled: roomDisabled
      }
    };

    await API.put("apiaada51cc", `/rooms/updateRoomStatus/${roomId}`, options).then(response => {
      // Add your code here
      setLoading(false);
    }).catch(error => {
      handleErrorClick();
      insertError(error);
    });
  }

  async function endRoomTime(currentTime, roomId) {
    setLoading(true);

    const options = {
      headers: { 'Content-Type': 'application/json', "Access-Control-Allow-Origin": "*" },
      body: {
        endTime: currentTime.toISOString(),
        price: 0
      }
    };
    API.put("apiaada51cc", `/rooms/updateTime/${roomId}`, options)
      .then(response => {
        setLoading(false);
      }).catch(error => {
        handleErrorClick();
        insertError(error);
      });

    await PubSub.publish(roomId, { msg: 'Timer Started' });
  }

  async function createTransaction(assetId, assetName, tracking, duration, price, endTime, startTime) {
    setLoading(true);
    if (assetName === "" || assetName === null) return new Error("Invalid Girl");
    if (price === 0 && tracking.includes("Room")) return new Error("Invalid Transaction");

    const options = {
      headers: { 'Content-Type': 'application/json', "Access-Control-Allow-Origin": "*" },
      body: {
        assetName: assetName,
        tracking: tracking,
        duration: duration,
        price: price,
        status: "Valid",
        startTime: startTime,
        endTime: endTime,
        tai: 0
      }
    };

    API.post("apiaada51cc", '/transactions', options)
      .then(response => {
        // Add your code here
        setLoading(false);
        updateTracking(assetId, tracking, 0)
      }).catch(error => {
        handleErrorClick();
        insertError(error);
      });

  }

  // async function getAssetTracking(assetName) {
  //   const getAssets = await API.get("apiaada51cc", "/assets");
  //   const tracking = getAssets.data.filter(it => assetName === it.assetName)[0].tracking;
  //   return tracking;
  // }

  async function getRoomStartTime(roomId) {
    const getRooms = await API.get("apiaada51cc", `/rooms/${roomId}`);
    return getRooms[0].startTime;
  }

  async function updateTransactionEndTime(assetsInRoom) {
    const currentTime = new Date().toISOString();

    setLoading(true);
    for (var assets in assetsInRoom) {
      var assetName = assetsInRoom[assets].assetName;
      if (assetName === "" || assetName === null) return new Error("Invalid Girl");

      await API.get("apiaada51cc", `/transactions/${assetName}`)
        .then(response => {
          const startTime = new Date(response[0].startTime).toISOString();
          const price = response[0].price;
          const options = {
            headers: { 'Content-Type': 'application/json', "Access-Control-Allow-Origin": "*" },
            body: {
              endTime: currentTime,
              price: price,
              status: "Valid"
            }
          };
          API.put("apiaada51cc", `/transactions/updateStatus/${assetName}/${startTime}`, options)
            .then()
            .catch(error => {
              handleErrorClick();
              insertError(error);
            });

        }).catch(error => {
          handleErrorClick();
          insertError(error);
        });
      updateTracking(assetsInRoom[assets].assetId, "Available", 0);
    }

    setLoading(false);
  }



  async function createTransactionDate(assetsInRoom, price, duration, tracking, status, roomId) {
    const endTime = new Date().toISOString();
    if (duration <= 0) duration = 0;
    const startTime = await getRoomStartTime(roomId);

    setLoading(true);
    for (var assets in assetsInRoom) {
      var assetName = assetsInRoom[assets].assetName;

      if (assetName === "" || assetName === null) return new Error("Invalid Girl");

      if (price === 0 && tracking.includes("Room") && status === "Valid") {
        price = await getAssetPrice(assetName);
      }

      const options = {
        headers: { 'Content-Type': 'application/json', "Access-Control-Allow-Origin": "*" },
        body: {
          assetName: assetsInRoom[assets].assetName,
          tracking: tracking,
          duration: duration,
          price: price,
          tai: Math.floor(price / 60),
          status: status,
          startTime: startTime,
          endTime: endTime
        }
      };

      await API.post("apiaada51cc", '/transactions', options);
      updateTracking(assetsInRoom[assets].assetId, "Available", 0);
    }

    setLoading(false);
  }



  async function updateRoom(roomId, endTime, startTime, price) {
    if (roomId === "" || roomId === null) return new Error("Invalid Room");
    setLoading(true);

    const options = {
      headers: { 'Content-Type': 'application/json', "Access-Control-Allow-Origin": "*" },
      body: {
        startTime: startTime,
        endTime: endTime,
        price: price,
        extend: false,
        extendPrice: 0
      }
    };
    API.put("apiaada51cc", `/rooms/${roomId}`, options)
      .then(response => {
        // Add your code here
        setLoading(false);
      })
      .catch(error => {
        handleErrorClick();
        insertError(error);
      });

    await PubSub.publish(roomId, { msg: 'Timer Started' });
  }

  function RoomsCard(props) {
    return (
      <Grid
        container
        spacing={2}
        direction="row"
        justify="flex-start"
        alignItems="center"
      >
        {assetList !== "" && props.map((key) =>
          <Grid item xs={6} sm={4} md={3} key={props.indexOf(key)}>
            <Timer
              roomName={key.roomName}
              roomType={key.type}
              endTime={key.endTime}
              roomId={key.roomId}
              roomDisabled={key.roomDisabled}
              extend={key.extend ? "Extend (+$" + key.extendPrice + ")" : ""}
              getRoomStartTime={getRoomStartTime}
              time={key.time}
              pubSub={pubSub}
              setPrice={setPrice}
              createTransactionDate={createTransactionDate}
              price={key.price || price}
              packages={packages}
              endRoomTime={endRoomTime}
              selectedAsset={selectedAsset}
              setSelectedAsset={setSelectedAsset}
              assetList={assetList}
              updateRoomStatus={updateRoomStatus}
              setLoading={setLoading}
              updateRoom={updateRoom}
              // getAssetTracking={getAssetTracking}
              updateTracking={updateTracking}
            />
          </Grid>
        )}
        <Grid item xs={6} sm={4} md={6}>
          {rooms !== "" &&
            <Reminder
              rooms={rooms}
            />
          }
        </Grid>
      </Grid>
    );
  }

  function LoadingCard(props) {
    return (
      <Grid
        container
        spacing={2}
        direction="row"
        justify="flex-start"
        alignItems="center"
      >
        {props.map((key) =>
          <Grid item xs={6} sm={4} md={3} key={props.indexOf(key)}>
            <LoadingTimer
              roomName={key.roomName}
              roomType={key.type}
              extend={key.extend}
              endTime={key.endTime}
              roomId={key.roomId}
            />
          </Grid>
        )}
        <Grid item xs={6} sm={4} md={6}>
          <Reminder
            rooms={initRooms}
          />
        </Grid>
      </Grid>
    );
  }

  return (
    <Container>
      <TopFields
        selectedAsset={selectedAsset}
        menuList={menuList}
        setSelectedAsset={setSelectedAsset}
        updateTracking={updateTracking}
        updateTransactionEndTime={updateTransactionEndTime}
        createTransaction={createTransaction}
        createTransactionDate={createTransactionDate}
        assetList={assetList}
      />
      <Box pt={2} />
      {rooms !== "" ? RoomsCard(rooms) : LoadingCard(initRooms)}
      <AssetGrid
        assetList={assetList}
        selectedAsset={selectedAsset}
        setSelectedAsset={setSelectedAsset}
        createTransaction={createTransaction}
        createTransactionDate={createTransactionDate}
        updateTransactionEndTime={updateTransactionEndTime}
        updateTracking={updateTracking}
      />
      <Snackbar open={errorOpen} autoHideDuration={6000} onClose={handleErrorClose}>
        <Alert onClose={handleErrorClose} severity="error">
          Oops something went wrong. Please try again.
        </Alert>
      </Snackbar>
      <Backdrop className={classes.backdrop} open={loading}>
        <CircularProgress color="inherit" />
      </Backdrop>
    </Container>
  );
}